<section class="call-notifications">
  <div class="call-notifications__container">
    <div class="call-notifications__title">
      <h2 class="title">{{ title | translate }}</h2>
      <mat-icon (click)="confirm()" class="cursor-pointer close-icon">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div class="call-notification__content">
      <div class="call-notification__description">
        <p>{{ prefix ? (prefix | translate) + ': ' : '' }}{{ info | translate }}</p>
      </div>
    </div>
  </div>
  <div class="call-notifications__buttons">
    <button mat-raised-button class="call-notifications__confirm" color="primary" (click)="confirm()">
      {{ 'OK' | translate }}
    </button>
  </div>
</section>
